<div class="message {{classType}}" [ngClass]="{'message--display': showMessage, 'message--center': options.alignCenter}">
  <span class="ms-icon icon-warn position-warm"></span>
  <p [innerHTML]="message"></p>
</div>
